import React from 'react';
import { useSelector } from 'react-redux';

// Own constants/actions/components
import ButtonFloat from 'components/button-float';
import HeaderContainer from 'containers/header';
import FooterContainer from 'containers/footer';
import NotFoundContainer from 'containers/notFound';
import { items } from 'services/selectors/shopping-cart';

const NotFoundPage = () => {
  const itemsCart = useSelector(items);

  return (
    <div>
      <ButtonFloat number={itemsCart.length} />
      <HeaderContainer />
      <NotFoundContainer />
      <FooterContainer />
    </div>
  );
};

export default NotFoundPage;
